import store from "@/store/store";
import {authService} from '@/modules/auth/services/authService.js';

const getInterceptors = (service) => {
  const REQUEST = {
    onFulfilled: config => {
      // Do something before request is sent
      const token = store.getters["auth/token"];
      const staff = store.getters["accountModule/staff"];
      const profile = store.getters["accountModule/profile"];
      const isCollaborator = store.getters["accountModule/isCollaborator"];

      // config.headers["x-app-name"] = "Frontage";

      if (!config.params){
        config.params = {}
      }

      if (staff && profile && staff.uid !== profile.staff.uid) {
        config.params.context_staff = staff.uid;
      }

      if (isCollaborator){
        config.params.teams_view_filter = store.getters["accountModule/teamsViewFilter"];
      }

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      return config;
    },

    onRejected: error => {
      // Do something with request error
      return Promise.reject(error);
    }
  }

  const RESPONSE = {
    onFulfilled: response => {
      return response;
    },

    onRejected: async error => {
      // Do something with response error
      if (error.response && error.response.status === 401) {
        let resp = await authService.getToken()
        if (resp.success){
          store.commit('auth/saveToken',resp.jwt)
          error.config.headers["Authorization"] = `Bearer ${resp.jwt}`;
          return service(error.config);
        } else {
          authService.logout();
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
  }

  return {
    REQUEST,
    RESPONSE
  }
}

export default getInterceptors;
